 const renderSuggestions = (data) => (
    <div className="suggestions">
      <div className="suggestions-header bg-gradient-to-r from-primary/20 to-accent/20 p-6 rounded-lg border border-primary/30 mb-6">
        <h3 className="text-xl font-bold text-primary mb-2 flex items-center">
          💡 Personalized Recommendations
        </h3>
        <p className="text-foreground">{data.analysis}</p>
      </div>

      {data.suggestions && data.suggestions.length > 0 && (
        <div className="suggestions-grid space-y-4">
          {data.suggestions.map((suggestion, index) => (
            <div key={index} className={`suggestion-card p-6 rounded-lg border bg-card ${
              suggestion.priority === 'high' ? 'border-destructive' :
              suggestion.priority === 'medium' ? 'border-yellow-500' :
              'border-primary'
            }`}>
              <div className="flex justify-between items-start mb-3">
                <h4 className="text-lg font-semibold text-foreground">{suggestion.title}</h4>
                <span className={`px-3 py-1 text-xs font-medium rounded-full ${
                  suggestion.priority === 'high' ? 'bg-destructive/20 text-destructive' :
                  suggestion.priority === 'medium' ? 'bg-yellow-500/20 text-yellow-500' :
                  'bg-primary/20 text-primary'
                }`}>
                  {suggestion.priority} priority
                </span>
              </div>

              <p className="text-card-foreground mb-3">{suggestion.description}</p>

              <div className="action-section bg-secondary p-3 rounded border border-border mb-3">
                <strong className="text-sm text-primary">🎯 Action:</strong>
                <p className="text-sm text-secondary-foreground mt-1">{suggestion.action}</p>
              </div>

              <div className="reason-section bg-secondary p-3 rounded border border-border mb-3">
                <strong className="text-sm text-accent">🔍 Why this helps:</strong>
                <p className="text-sm text-secondary-foreground mt-1">{suggestion.reason}</p>
              </div>

              {suggestion.measurable && (
                <div className="metrics-section bg-secondary p-3 rounded border border-border">
                  <strong className="text-sm text-primary">📊 Track progress:</strong>
                  <p className="text-sm text-secondary-foreground mt-1">{suggestion.measurable}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  export default renderSuggestions;